import React from 'react';
import { useLang } from '../context/LanguageContext';
import { Award, ShieldCheck, Users, Sparkles, MapPin, TrendingUp } from 'lucide-react';

const About = () => {
  const { t, lang, dir } = useLang();

  const values = [
    { icon: Sparkles, title: t('about.v1'), desc: t('about.v1d') },
    { icon: ShieldCheck, title: t('about.v2'), desc: t('about.v2d') },
    { icon: Users, title: t('about.v3'), desc: t('about.v3d') },
    { icon: Award, title: t('about.v4'), desc: t('about.v4d') }
  ];

  return (
    <div className="pt-28 pb-16" dir={dir}>
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#2563eb] mb-4">— {t('nav.about')} —</div>
          <h1 className="font-display text-5xl md:text-6xl text-[#0a0a0a]">{t('about.title')}</h1>
          <p className="mt-4 text-[#111827]/60 max-w-2xl mx-auto">{t('about.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-24">
          <div className="relative aspect-[4/5] rounded-2xl overflow-hidden glass-card">
            <img src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=1200&q=80" alt="Dubai" className="absolute inset-0 w-full h-full object-cover opacity-80" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#f8fafc] via-transparent to-transparent" />
          </div>
          <div>
            <h2 className="font-display text-3xl md:text-4xl text-[#0a0a0a] mb-6">{t('about.mission_title')}</h2>
            <p className="text-[#111827]/70 leading-relaxed text-lg">{t('about.mission')}</p>
            <div className="mt-8 grid grid-cols-3 gap-6">
              {[
                { num: '2015', label: lang === 'ar' ? 'التأسيس' : 'Established' },
                { num: '2,000+', label: lang === 'ar' ? 'شركة' : 'Companies' },
                { num: '40+', label: lang === 'ar' ? 'دولة' : 'Countries' }
              ].map((s, i) => (
                <div key={i}>
                  <div className="font-display text-3xl gold-text">{s.num}</div>
                  <div className="text-xs text-[#111827]/50 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="font-display text-4xl text-[#0a0a0a]">{t('about.values_title')}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={i} className="glass-card rounded-2xl p-8 text-center">
                <div className="w-14 h-14 mx-auto rounded-xl bg-gradient-to-br from-[#2563eb]/25 to-[#2563eb]/5 border border-[#2563eb]/25 flex items-center justify-center mb-5">
                  <v.icon className="w-6 h-6 text-[#3b82f6]" />
                </div>
                <h3 className="font-display text-xl text-[#0a0a0a] mb-2">{v.title}</h3>
                <p className="text-sm text-[#111827]/60 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
